import { useMemo } from 'react';

import qs from 'qs';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';

type Result = ModelHookResult<{
	shareButtonUrl: string;
	promoteButtonUrl: string;
	advocateEntryPointUrl: string;
}>;

export function usePromoteOrShareActionUrls(): Result {
	const {
		data: {
			petition: { slug },
			chipInAmount,
			chipInCurrencyCode,
		},
	} = usePsfPromoteOrSharePageData();
	const commonParams = useCommonParams();

	return {
		data: {
			shareButtonUrl: useMemo(
				() =>
					`/p/${encodeURIComponent(slug)}/psf/share${qs.stringify(
						{
							...commonParams,
							share_intent: 1,
							psf_combo_static_amount: chipInAmount,
							psf_combo_static_currency: chipInCurrencyCode,
						},
						{ addQueryPrefix: true },
					)}`,
				[slug, commonParams, chipInAmount, chipInCurrencyCode],
			),
			promoteButtonUrl: useMemo(
				() =>
					`/p/${encodeURIComponent(slug)}/promote${qs.stringify(
						{
							...commonParams,
							psf_combo_static_amount: chipInAmount,
						},
						{ addQueryPrefix: true },
					)}`,
				[slug, commonParams, chipInAmount],
			),
			advocateEntryPointUrl: useMemo(() => `/p/${encodeURIComponent(slug)}/advocates`, [slug]),
		},
	};
}

function useCommonParams() {
	const sourceLocation = useQueryParamValue('source_location');
	const guest = useQueryParamValue('guest');
	const shortDisplayName = useQueryParamValue('short_display_name');

	return useMemo(
		() => ({
			source_location: sourceLocation || 'combo_psf',
			psf_variant: 'combo',
			...(['new', 'existing'].includes(guest || '') ? { from_guest_psf: '1' } : undefined),
			...(shortDisplayName ? { short_display_name: shortDisplayName } : undefined),
		}),
		[sourceLocation, guest, shortDisplayName],
	);
}
